export const isUndefinedOrNull = <T>(value: T) => {
  return value === undefined || value === null;
};
